import { render, staticRenderFns } from "./RoomCBTInfoItem.vue?vue&type=template&id=2c160f86&"
import script from "./RoomCBTInfoItem.vue?vue&type=script&lang=js&"
export * from "./RoomCBTInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c160f86')) {
      api.createRecord('2c160f86', component.options)
    } else {
      api.reload('2c160f86', component.options)
    }
    module.hot.accept("./RoomCBTInfoItem.vue?vue&type=template&id=2c160f86&", function () {
      api.rerender('2c160f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTInfoItem.vue"
export default component.exports